/**
 * Generates a consistent color based on initials.
 * Used for avatar backgrounds and collaboration user colors.
 */
export const getColorFromInitials = (name: string, surname: string): string | null => {
  if (!name || !surname || name.length === 0 || surname.length === 0) {
    return null;
  }
  const nameInitial = name.charAt(0).charCodeAt(0);
  const surnameInitial = surname.charAt(0).charCodeAt(0);
  const maxRGBValue = 220;

  const red = (nameInitial * 123 + surnameInitial * 321) % maxRGBValue;
  const green = (nameInitial * 456 + surnameInitial * 654) % maxRGBValue;
  const blue = (nameInitial * 789 + surnameInitial * 987) % maxRGBValue;

  return `rgb(${red}, ${green}, ${blue})`;
};
